import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { UserListsCarousel, Lists } from '@thd-olt-component-react/user-lists';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { ImpressionProvider } from '@thd-olt-component-react/impression';
import { HomepageContext } from './context';
import { CUSTOMER_TYPES } from '../utils';

export function UserList({ id, customRenderId }) {
  const { customerType, isB2C } = useContext(HomepageContext);
  const { channel } = useContext(ExperienceContext);
  const title = customerType === CUSTOMER_TYPES.B2B ? 'My Product Lists' : 'My Lists';

  if (customRenderId === 'User List V2') {
    const data = {
      name: 'UserLists',
      component: 'UserLists',
      type: 'content',
      position: '',
      id
    };

    return (
      <ErrorBoundary name="user-lists-v2">
        <QueryProvider key={id} cacheKey={id}>
          <ImpressionProvider data={data}>
            <div
              id={`user-list-php-${id}`}
              className="sui-h-full"
            >
              <Lists componentId={id} />
            </div>
          </ImpressionProvider>
        </QueryProvider>
      </ErrorBoundary>
    );
  }
  return (
    <ErrorBoundary name="user-lists">
      <QueryProvider key={id} cacheKey={id}>
        <div
          id={`user-list-php-${id}`}
          className="sui-h-full"
        >
          <UserListsCarousel
            title={title}
            entryId={id}
            hideCarouselArrows={channel === 'mobile'}
            radiusUpdate={isB2C}
          />
        </div>
      </QueryProvider>
    </ErrorBoundary>
  );
}

UserList.propTypes = {
  id: string,
  customRenderId: string
};

UserList.defaultProps = {
  id: undefined,
  customRenderId: undefined
};
